(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sticky-atc"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sticky-atc')) {
    class StickyAtc extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.button = this.querySelector('[data-sticky-button]');
        this.buttonText = this.querySelector('[data-sticky-button-text]');
        this.select = this.querySelector('[data-sticky-select]');
        this.priceEl = this.querySelector('[data-sticky-price]');
        this.compareEl = this.querySelector('[data-sticky-compare]');
        this.imageEl = this.querySelector('.sticky-atc__image');
        this.variants = JSON.parse(this.querySelector('[data-sticky-variants]').textContent);

        this.button.addEventListener('click', () => this.mainButton()?.click());
        this.select?.addEventListener('change', () => this.onSelectChange());
        if (typeof subscribe === 'function') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => this.onVariantChange(event));
        }

        const mainButton = this.mainButton();
        if (!mainButton) return;
        this.observer = new IntersectionObserver(([entry]) => {
          this.classList.toggle('is-visible', !entry.isIntersecting);
        }, { threshold: 0.15 });
        this.observer.observe(mainButton);
      }

      mainButton() {
        return document.getElementById(`ProductSubmitButton-${this.sectionId}`);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.unsubscribe?.();
        this.releaseScroll?.();
      }

      onSelectChange() {
        const variant = this.variants.find((item) => String(item.id) === this.select.value);
        const root = document.getElementById(`variant-selects-${this.sectionId}`);
        if (!variant || !root) return;

        const scrollY = window.scrollY;
        const scrollTo = window.scrollTo.bind(window);
        const focus = HTMLElement.prototype.focus;
        window.scrollTo = () => {};
        HTMLElement.prototype.focus = function (options) {
          return focus.call(this, { ...(options && typeof options === 'object' ? options : {}), preventScroll: true });
        };
        this.releaseScroll = () => {
          if (window.scrollTo === scrollTo) return;
          window.scrollTo = scrollTo;
          HTMLElement.prototype.focus = focus;
          scrollTo(0, scrollY);
        };

        [variant.option1, variant.option2, variant.option3].filter(Boolean).forEach((value) => {
          const radio = [...root.querySelectorAll('input[type="radio"]')].find((input) => input.value === value);
          if (radio && !radio.checked) radio.click();
          const select = [...root.querySelectorAll('select')].find((item) => [...item.options].some((option) => option.value === value));
          if (select && select.value !== value) {
            select.value = value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });

        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => this.releaseScroll?.(), 1200);
      }

      onVariantChange({ data }) {
        if (!data || data.sectionId !== this.sectionId || !data.variant) return;
        const variant = this.variants.find((item) => item.id === data.variant.id);
        if (!variant) return;
        if (this.select && this.select.value !== String(variant.id)) this.select.value = String(variant.id);
        if (this.priceEl) this.priceEl.textContent = variant.price;
        if (this.compareEl) {
          this.compareEl.hidden = !variant.compare;
          this.compareEl.textContent = variant.compare || '';
        }
        if (this.imageEl && variant.image) this.imageEl.src = variant.image;
        if (this.buttonText) this.buttonText.textContent = variant.available ? this.dataset.addLabel : this.dataset.soldLabel;
        if (this.button) this.button.disabled = !variant.available;
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => this.releaseScroll?.(), 60);
      }
    }

    customElements.define('sticky-atc', StickyAtc);
  }
  } catch(e) { console.error(e); }
})();

})();
